import configJSON from 'config.json';

export const isServerSide = () => (typeof window === 'undefined');

export const isClientSide = () => (typeof window !== 'undefined');

export const getInsightsHost = (isServerSide: boolean) => isServerSide ? configJSON.services.insights.serverSideHost : configJSON.services.insights.clientSideHost;

export const getGoSearchHost = (isServerSide: boolean) => isServerSide ? configJSON.services.search.serverSideHost : configJSON.services.search.clientSideHost;

export const getClientAppHost = (isServerSide: boolean) => isServerSide ? configJSON.services.clientApp.serverSideHost : configJSON.services.clientApp.clientSideHost;

export const getCmsHost = () => configJSON.services.cms;

export const getWalkScoreHost = () => configJSON.services.walkScore;

export const getProviderComplianceHost = () => configJSON.providerTermsOfUseHost;

/**
 * Get the storage service host for the given tenant.
 *
 * @param isServerSideHost Whether the host is for the server side or client side. Defaults to the value of {@link isServerSide isServerSide()}.
 * @returns The storage service host.
 */
export const getStorageServiceHost = (isServerSideHost: boolean = isServerSide()) => isServerSideHost ? configJSON.services.storage.serverSideHost : configJSON.services.storage.clientSideHost;